
import Vue from 'vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  mixins: [staticBlockMixin],
  props: {
    makeHorizontal: {
      type: Boolean,
      required: false,
      default: false
    }
  }
})
